import { ShieldLockIcon } from '@navikt/aksel-icons';
import { Button } from '../Button';
import { SSOConnectionUtils } from '../../features/sso/utils/ssoConnectionUtils';
import { ConnectionCardProps } from './types';
import classes from './SSOSettings.module.css';

export const ConnectionCard = ({
  connection,
  uiStateManager,
  onDisable,
  onReEnable,
  t,
}: ConnectionCardProps) => {
  const isActive = SSOConnectionUtils.isConnectionActive(connection);

  return (
    <div className={`${classes.connectionCard} ${isActive ? classes.connectionCardActive : classes.connectionCardDisabled}`}>
      <div className={classes.connectionCardContent}>
        <div className={classes.connectionCardHeader}>
          <div className={classes.connectionProvider}>
            <ShieldLockIcon className={classes.providerIcon} aria-hidden />
            <span className={classes.providerName}>Microsoft Entra ID</span>
          </div>
          <span className={`${classes.statusBadge} ${isActive ? classes.statusBadgeActive : classes.statusBadgeDisabled}`}>
            {isActive ? t('ssoSettings.status.active', { defaultValue: 'Aktiv' }) : t('ssoSettings.status.disabled', { defaultValue: 'Deaktivert' })}
          </span>
        </div>

        <div className={classes.connectionCardDetails}>
          {connection.entraIdDomain && (
            <div className={classes.detailRow}>
              <span className={classes.detailLabel}>{t('ssoSettings.activeConnections.domain')}:</span>
              <span className={classes.detailValue}>{connection.entraIdDomain}</span>
            </div>
          )}
          <div className={classes.detailRow}>
            <span className={classes.detailLabel}>{t('ssoSettings.activeConnections.created')}:</span>
            <span className={classes.detailValue}>
              {SSOConnectionUtils.formatCreatedDate(connection.createdAt)}
            </span>
          </div>
        </div>
      </div>

      <div className={classes.connectionCardActions}>
        {uiStateManager.shouldShowDisableButton(connection) ? (
          <Button variant="secondary" size="medium" onClick={() => onDisable(connection.id)}>
            {t('ssoSettings.activeConnections.disableButton')}
          </Button>
        ) : (
          <Button variant="success" size="medium" onClick={onReEnable}>
            {t('ssoSettings.activeConnections.reEnableButton')}
          </Button>
        )}
      </div>
    </div>
  );
};
